
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Flex, Spinner, Text, Stack } from '@chakra-ui/react';
import useServerApi from '../../../../hooks/useServerApi';
import Filters from './Filters';
import DataDisplay from './DataDisplay';
import AgentAnalytics from 'components/page-components/agents/AgentAnalytics';


const CallHistory = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [{ get, post }] = useServerApi();

    const [loading, setLoading] = useState(false);
    const [calls, setCalls] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [size, setSize] = useState(10);
    const [filters, setFilters] = useState({
        callerPhoneNumber: '',
        startDatetime: null,
        endDatetime: null,
        isDelete: false,
        blockedOnly: false
    });
    const [editMode, setEditMode] = useState(false);

    const fetchCallHistory = async () => {
        setLoading(true);
        try {
            const requestData = {
                page,
                size,
                caller_phone_number: filters.callerPhoneNumber,
                start_datetime: filters.startDatetime,
                end_datetime: filters.endDatetime,
                is_delete: filters.isDelete,
                blocked_only: filters.blockedOnly
            };

            const [success, result] = await post('/rest_endpoints/call_history/history', requestData);

            if (success && result?.data?.calls) {
                setCalls(result.data.calls);
            }
            setPages(result.data.pages || 1);
            setPage(result.data.page || 1);
        } catch (err) {
            console.error('Error fetching call history:', err);
        } finally {
            setLoading(false);
        }
    };

    function getSixMonthsBackTimestamp() {
        const now = new Date();
        const sixMonthsAgo = new Date(now.setMonth(now.getMonth() - 6));
        return sixMonthsAgo.getTime();
    }

    useEffect(() => {
        fetchCallHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, page, size]);

    useEffect(() => {
        if (id && !isNaN(id)) {
            navigate('/view-recording/' + id);
        }
    }, [id, navigate]);

    const startTimestamp = filters.startDatetime ? new Date(filters.startDatetime).getTime() : getSixMonthsBackTimestamp();
    const endTimestamp = filters.endDatetime
        ? new Date(filters.endDatetime).getTime()
        : null;

    return (
        <Box mb='20px'>
            <Flex mb='20px' justifyContent='space-between' alignItems='center'>
                <Flex gap='20px' alignItems='center'>
                    <Text className='text-2xl' fontWeight='bold' lineHeight='19px' letterSpacing='0em'>
                        Call History
                    </Text>
                    {(filters.callerPhoneNumber || filters.startDatetime || filters.endDatetime || filters.isDelete || filters.blockedOnly) && (
                        <Text color="blue.500" fontSize="sm">(Filtered)</Text>
                    )}
                </Flex>
                <Flex alignItems='center' gap='10px'>
                    {loading && (
                        <Spinner size='sm' />
                    )}
                </Flex>
            </Flex>



            <Stack spacing='5'>
                <Filters
                    filters={filters}
                    setFilters={setFilters}
                    editMode={editMode}
                    setEditMode={setEditMode}
                />
                {/* Agent Analytics charts above call history */}
                <AgentAnalytics startTimestamp={startTimestamp} endTimestamp={endTimestamp} />
                <DataDisplay
                    calls={calls}
                    loading={loading}
                    onPageChange={(newPage) => setPage(newPage)}
                    onSizeChange={(newSize) => setSize(newSize)}
                    currentPage={page}
                    pageSize={size}
                    totalPages={pages}
                    refreshData={fetchCallHistory}
                    editMode={editMode}
                    filters={filters}
                    setEditMode={setEditMode}
                />
            </Stack>
        </Box>
    );
};

export default CallHistory;